import { FetchStatus } from '@server/fetch_status.type';

export const isOrgConnectionError = (fetchStatus: FetchStatus) =>
  [FetchStatus.InvalidCredentials, FetchStatus.Error].includes(fetchStatus);
